import { BookingStep, BookingStepName } from "types/bookingv2/booking"

/**
 * Parameters for navigation between booking steps
 */
interface StepNavigationParams {
    /** List of available steps in the booking flow */
    availableSteps: BookingStepName[]
    /** Current step configuration */
    currentStep: BookingStep
    /** Previous step configuration or undefined if at first step */
    prevStep: BookingStep | undefined
    /** Next step configuration or undefined if at last step */
    nextStep: BookingStep | undefined
    /** Function to set the current step name */
    setCurrentStepName: (step: BookingStepName) => void
    /** Optional router for navigation to external pages */
    router?: any
    /** Optional event ID for building the checkout URL */
    eventId?: string
}

/**
 * Navigates to the next step in the booking flow
 * @param params Navigation parameters
 */
export const getNextStepAction = ({
    availableSteps,
    currentStep,
    nextStep,
    setCurrentStepName,
    router,
    eventId,
}: StepNavigationParams): void => {
    const currentStepIndex = availableSteps.indexOf(currentStep.name)

    // If next step is checkout, redirect to the checkout page instead.
    // Encode the current step as `from` so the checkout back button can
    // return to it directly without needing shared React state.
    if (
        nextStep &&
        nextStep.name === BookingStepName.CHECKOUT &&
        router &&
        eventId
    ) {
        const fromStep = currentStep.name
            .toLowerCase()
            .replace(/\s+/g, "_")
        router.push(`/events/${eventId}/book/checkout?from=${fromStep}`)
        return
    }

    if (nextStep && currentStepIndex < availableSteps.length - 1) {
        setCurrentStepName(availableSteps[currentStepIndex + 1])
    }
}

/**
 * Navigates to the previous step in the booking flow
 * @param params Navigation parameters
 */
export const getPrevStepAction = ({
    availableSteps,
    currentStep,
    prevStep,
    setCurrentStepName,
}: StepNavigationParams): void => {
    const currentStepIndex = availableSteps.indexOf(currentStep.name)
    if (prevStep && currentStepIndex > 0) {
        setCurrentStepName(availableSteps[currentStepIndex - 1])
    }
}
